import React from 'react';
import { Box, Typography, Button, Skeleton, Stack } from '@mui/material';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import { tokens } from '../../theme';

export const ErrorState = ({ message, onRetry, compact = false }) => (
  <Box role="alert" sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, p: compact ? 2 : 3, borderRadius: 2, bgcolor: tokens.errorSoft }}>
    <ErrorOutlineRoundedIcon sx={{ color: tokens.error, mt: '2px' }} />
    <Box sx={{ flex: 1 }}>
      <Typography variant="subtitle2" sx={{ color: tokens.error }}>Не удалось загрузить данные</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>{message}</Typography>
    </Box>
    {onRetry && <Button size="small" variant="outlined" onClick={onRetry}>Повторить</Button>}
  </Box>
);

export const CardsSkeleton = ({ count = 3, height = 220 }) => (
  <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} aria-busy="true" aria-label="Загрузка">
    {Array.from({ length: count }).map((_, i) => (
      <Skeleton key={i} variant="rounded" height={height} sx={{ flex: 1, borderRadius: 4 }} />
    ))}
  </Stack>
);
